<template>
  <w-icon-wrapper
    :height='23.998'
    :width='23.998'
    icon-name='work-refresh-icon'
    view-box='0 0 23.998 23.998'
  >
    <g
      id='_29_Aktualisieren_Icon'
      data-name='29 Aktualisieren_Icon'
      transform='translate(0 -0.003)'
    >
      <path
        id='Pfad_55698'
        d='M23.83,10H21.8A10.011,10.011,0,0,1,9.79,21.753a9.664,9.664,0,0,1-4.59-2.44H6.82a1,1,0,0,0,0-2H1.62v5.2a1,1,0,1,0,2,0v-1.93a11.947,11.947,0,0,0,3.93,2.57,12.049,12.049,0,0,0,16.15-8.5A11.959,11.959,0,0,0,23.83,10Z'
        data-name='Pfad 55698'
        fill='currentColor'
      />
      <path
        id='Pfad_55699'
        d='M2.248,9.8a10.01,10.01,0,0,1,11.96-7.55A9.664,9.664,0,0,1,18.8,4.69h-1.62a1,1,0,0,0,0,2h5.2V1.49a1,1,0,0,0-2,0V3.42A11.947,11.947,0,0,0,16.448.85,12.049,12.049,0,0,0,.3,9.35,11.959,11.959,0,0,0,.168,14H2.2A9.92,9.92,0,0,1,2.248,9.8Z'
        data-name='Pfad 55699'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconRefresh' };
</script>
